module.exports = __webpack_public_path__ + "img/Sichtschutz.8d2e9141.jpg";